export const ACCESS_TYPE = 'ws'; // ws or sse 标志链接方式
export const APP_KEY = 'pYzCFJGSAoydpoXVnoBwDRqHRWPugRBshfiWMdSrUapVToCRBKkoizOjZGUQTnyJrZjaUQYilvEpHmcLdRoerMYsQFwORZLMcpjVTrNmyMfCkweBshLaqGEUXBAuUCUH'; // 体验机器人的appkey



// WEBPACK FOOTER //
// ./src/constants/static.js